import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryParams } from '@core/shared/util';
import { AttributeFacet } from '@mp/shared/facets/domain';

import {
  ArticleFacetDrilldownSearchRequest,
  ArticleFacetSearchRequest,
  ArticleSearchBaseParams,
  FacetResult,
} from '../models';

@Injectable()
export class FacetsService {
  private readonly baseUrl = '/api/medical-shop2/articles';

  constructor(private readonly http: HttpClient) {}

  /**
   * Fetches the facets based on the given request.
   *
   * @param request The search request.
   * @returns The facet result.
   */
  fetchFacets(request: ArticleFacetSearchRequest): Observable<FacetResult> {
    const params = this.buildQueryParams(request)
      .param('minCount', request.minCount)
      .param('expandLimit', request.expandLimit)
      .param('eClassFeaturesDrilldown', request.eClassFeaturesDrilldown)
      .param('articleFeaturesDrilldown', request.articleFeaturesDrilldown)
      .param('pharmaceuticalFeaturesDrilldown', request.pharmaceuticalFeaturesDrilldown)
      .toHttpParams();

    return this.http.get<FacetResult>(`${this.baseUrl}/facets`, { params });
  }

  /**
   * Fetches a specific attribute facet based on the given drillown request.
   *
   * @param request The drilldown search request.
   * @returns The attribute facet as a replacement of the current corresponding value of `FacctResult`.
   */
  fetchFacetDrilldown(request: ArticleFacetDrilldownSearchRequest): Observable<AttributeFacet> {
    const params = this.buildQueryParams(request)
      .param('minCount', request.minCount)
      .param('expandLimit', request.expandLimit)
      .param('facetType', request.facetType)
      .param('drilldown', request.drilldown)
      .toHttpParams();

    return this.http.get<AttributeFacet>(`${this.baseUrl}/facetsdrilldown`, {
      params,
    });
  }

  private buildQueryParams(request: ArticleSearchBaseParams): QueryParams<ArticleSearchBaseParams> {
    return QueryParams.build<ArticleSearchBaseParams>()
      .param('query', request.query)
      .param('field', request.field)
      .param('suppliers', request.suppliers)
      .param('manufacturers', request.manufacturers)
      .param('eClassFeatures', request.eClassFeatures)
      .param('articleFeatures', request.articleFeatures)
      .param('pharmaceuticalFeatures', request.pharmaceuticalFeatures)
      .param('category', request.category)
      .param('categoryType', request.categoryType)
      .param('clinicCatalog', request.clinicCatalog);
  }
}
